import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import apiService from 'app/services/apiService';
import { setSelectedOrg } from 'app/store/features/orgSelectSlice';
import appService from 'app/services/appService';
import { fetchAccountSettings, resetAppState, showAlert } from '..';
import { routes } from 'app/routes';

export const useSwapToken = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const swapToken = useCallback(async (orgId) => {
    if(!orgId) return;
    try {
      const res = await apiService.swapToken(orgId);

      if (res.data.status === 'success') {
        appService.setCookie(res.data.accessToken);
        dispatch(setSelectedOrg(orgId));
        showAlert('success', "Succesfully logged in to organisation");
        resetAppState({ preserve: ['orgSelect'], reload: false });
        fetchAccountSettings();
        navigate(routes.HOME);
      } else {
        showAlert('error', "unable to log in to chosen organisation");
      }
    } catch (error) {
      console.error('Error swapping token', error);
      showAlert('error', "unable to log in to chosen organisation");
    }
  }, [dispatch, navigate]);

  return swapToken;
};
